// The worker in `public/stored-images-sw.js` keeps stored images by path; its cache name must match.
const CACHE_NAME = "stored-images";

/** Starts the worker that keeps each stored image a browser downloaded, across the daily change of its signed link. */
export function registerStoredImagesCache() {
  if (!("serviceWorker" in navigator)) {
    return;
  }

  // Without the worker images still load, only downloaded again each day.
  void navigator.serviceWorker.register("/stored-images-sw.js").catch(() => undefined);
}

/** A shared browser must not keep the family's photos after logout. */
export function clearStoredImagesCache() {
  if (typeof caches === "undefined") {
    return;
  }

  void caches.delete(CACHE_NAME).catch(() => {
    // persistence-best-effort: logout must finish even when the browser refuses to clear its storage.
  });
}
